import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { reportScreen } from '../../services/analyticsService';
import { Page } from '../../components/layout';
import { AccountDetails } from './Components/AccountDetails';

export default () => {
  const { buyerName } = useParams();
  useDocumentTitle(`${buyerName}`);
  useEffect(() => {
    reportScreen('account page');
  }, []);

  return (
    <Page>
      <AccountDetails />
    </Page>
  );
};
